export const localStorageNames = {
  clientData: 'clientData',
  studentData: 'studentData',
  refreshToken: 'trt',
  serviceToken: 'serviceToken',
  organizationSlug: 'organizationSlug',
  organizationLogo: 'organizationLogo',
  assistantPanelWidth: 'assistantPanelWidth',
};
